import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { AccountService } from '@qaroni-app/account/services/account.service';
import { Account } from '@qaroni-app/account/types/account';
import { MenuItems } from '@qaroni-app/layout/types/menu-item';
import { QaroniMatDialog } from '@qaroni-core/conf/dialog/qaroni-mat-dialog';
import { ImagesConfig } from '@qaroni-core/conf/images/images.config';
import { QaroniDialogConfig } from '@qaroni-core/types/qaroni-dialog.config';
import { QaroniMatDialogConfigDataAnimateRTLSm } from '@qaroni-core/types/qaroni-mat-dialog-config-data-animate';
import { DialogAccountComponent } from '@qaroni-shared/components/dialog-account/dialog-account.component';
import { MenuItemComponent } from '../menu-item/menu-item.component';

@Component({
  selector: 'qaroni-menu',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    MenuItemComponent,
    RouterLink,
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent
  extends QarepaBaseSubsDirective
  implements OnInit, OnChanges
{
  @Input() isMenuOpen = false;
  @Output() closeMenu = new EventEmitter<boolean>();
  @Output() openProfile = new EventEmitter<boolean>();

  public ImagesConfig = ImagesConfig;
  public MenuItems = MenuItems;
  public account: Account | null = null;
  public image = ImagesConfig.avatar.src;

  private accountService = inject(AccountService);
  private _cdr = inject(ChangeDetectorRef);
  public dialog = inject(QaroniMatDialog);

  public account$ = this.accountService.account$;
  private messageAccount$ = this.accountService.getMessage$();

  ngOnInit(): void {
    this.subs.add(this.account$.subscribe(this.getAccount));
    this.subs.add(this.messageAccount$.subscribe(this.getMessage));

    this.accountService.account();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const isMenuOpen = changes['isMenuOpen'].currentValue as boolean;
    this.isMenuOpen = isMenuOpen;
  }

  private getAccount = (account: Account | null): void => {
    if (!account) {
      return;
    }

    this.account = account;
    this.image = `${account.image}`;
    this._cdr.markForCheck();
  };

  private getMessage = (message: string): void => {
    if (!message) {
      return;
    }

    if (message.includes('Delete done')) {
      this.dialog.closeAll();
      this.accountService.account();
    }
  };

  public isLgScreen(): boolean {
    return window.innerWidth >= 1024;
  }

  public close(): void {
    this.isMenuOpen = false;
    this.closeMenu.emit(this.isMenuOpen);
  }

  public profile(): void {
    this.close();
    this.closeMenu.emit(this.isMenuOpen);
    const dialogConfig = new QaroniDialogConfig<Account>(
      QaroniMatDialogConfigDataAnimateRTLSm
    );

    dialogConfig.data = this.account;
    this.dialog.customOpen<DialogAccountComponent, Account, boolean>(
      DialogAccountComponent,
      dialogConfig
    );
  }
}
